import { useParams } from "react-router-dom";
import { useIntl } from "@leagueplatform/locales";
import { usePageViewAnalytics } from "@leagueplatform/analytics";
import { useDocumentTitle } from "@leagueplatform/web-common";
import { Masonry } from "@leagueplatform/masonry";
import { Box } from "@leagueplatform/genesis-core";
import { MASONRY } from "common/constants";
import { PageContentWrapper } from "components/page-content-wrapper.component";
import { BackButtonArrow } from "components/back-button-arrow/back-button-arrow.component";

export const CareLibraryTopicPage = () => {
  const { tag = "" } = useParams<{ tag: string }>();
  const { formatMessage } = useIntl();

  usePageViewAnalytics({ screen_name: "topic details page" });
  useDocumentTitle(formatMessage({ id: "STR_EXPLORE" }));

  return (
    <PageContentWrapper>
      <Box css={{ paddingBlock: "$two", isolation: "isolate" }}>
        <BackButtonArrow
          analyticsEventProps={{ screen_name: "topic details page" }}
        />
      </Box>
      <Masonry
        rootNodeId={MASONRY.ROOT_NODE_ID_CARE_LIBRARY_TOPIC_PAGE}
        initialQueryParams={{ tag }}
      />
    </PageContentWrapper>
  );
};
